import React, { useState, useEffect } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import {
    Box,
    Typography,
    Button,
    Grid,
    Paper,
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell
} from '@mui/material';
import { createTheme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import FactCheckIcon from '@mui/icons-material/FactCheck';
import BaseFormWrapper from "../../components/shared/BaseFormWrapper";
import logo from "../../images/BPMC_Logo.png";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import {
  normalizeJobTypeKeyToLabel,
  normalizeJobDescriptionKeyToLabel,
  normalizeDocumentKeyToLabel,
  normalizeEquipmentKeyToLabel,
} from "../JobOrders/utils/JobOrderConstants";

const theme = createTheme({
    palette: {
        primary: {
            main: "#1e5d45", // Custom primary color
        },
    },
});

const StyledHr = styled("hr")(({ theme }) => ({
    border: 0,
    borderTop: `1px solid ${theme.palette.divider}`,
    // margin: theme.spacing(4, 0),
    opacity: 0.8,
}));

const formatJobDateToDDMMMYYYY = (dateString) => {
    // Create a Date object from the "YYYY-MM-DD" string
    const dateObj = new Date(dateString);
    // Format the day with a leading zero if necessary
    const day = String(dateObj.getDate()).padStart(2, "0");
    // Define the abbreviated month names
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    // Get the month abbreviation
    const monthAbbrev = monthNames[dateObj.getMonth()];
    // Get the full year
    const year = dateObj.getFullYear();
    // Return the formatted date string
    return `${day}-${monthAbbrev}-${year}`;
};

const formatList = (arr, normalizer) =>
  Array.isArray(arr) ? arr.map(normalizer).join(", ") : "";


const PrintComponent = ({ group, convertToAmPm }) => {
    return (
        <>
            <style>
                {`
                    @page {
                    size: Letter landscape;
                    margin: 5mm 5mm; /* 10mm top/bottom, 5mm left/right narrow margin */
                    }
                    /* Hide the print component on screen */
                    .print-only {
                    display: none;
                    }
                    /* When printing, show only the print-area */
                    @media print {
                    .print-only {
                        display: block;
                    }
                    /* Hide everything except print-area */
                    body * {
                        visibility: hidden;
                    }
                    #print-area, #print-area * {
                        visibility: visible;
                    }
                    #print-area {
                        position: absolute;
                        left: 0;
                        top: 0;
                    }
                    }
                `}
            </style>

            {/* Wrap the print content in a container that is hidden on screen */}
            <div className="print-only" id="print-area">
                <Grid container spacing={1}>
                    {/* Header information */}
                    <Grid item xs={12}>
                        <Grid container spacing={1} sx={{ mb: 1 }}>
                            <Grid item xs={3}>
                                <Grid container spacing={1}>
                                    <table
                                        style={{
                                            fontSize: '11px',
                                            borderCollapse: 'collapse',
                                            marginLeft: '10px',
                                            marginTop: '10px',
                                            width: '100%'
                                        }}
                                    >
                                        {/* <tbody>
                                            <tr>
                                                <td style={{ padding: '4px', border: '1px solid #ccc' }}>
                                                    Date
                                                </td>
                                                <td style={{ padding: '4px', border: '1px solid #ccc' }}>
                                                    {group.jobOrders[0]?.job_date
                                                        ? new Date(group.jobOrders[0]?.job_date)
                                                            .toLocaleDateString('en-GB', {
                                                                day: '2-digit',
                                                                month: 'short',
                                                                year: '2-digit'
                                                            })
                                                            .replace(/ /g, '-')
                                                        : ''}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '4px', border: '1px solid #ccc' }}>
                                                    Technicians
                                                </td>
                                                <td style={{ padding: '4px', border: '1px solid #ccc' }}>
                                                    {group.technicians
                                                        .map(
                                                            (tech) => `${tech.firstname} ${tech.lastname}`
                                                        )
                                                        .join(', ')}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '4px', border: '1px solid #ccc' }}>
                                                    Driver
                                                </td>
                                                <td style={{ padding: '4px', border: '1px solid #ccc' }}>
                                                    {group.jobOrders[0]?.endorsement_form_driver}
                                                </td>
                                            </tr>
                                        </tbody> */}
                                        <tbody>
                                            {/* Row 1: Date | {job_date} | Dispatch Time | {endorsement_dispatch_time} */}
                                            <tr>
                                                <td style={{ padding: '4px', border: '1px solid #ccc' }}>Date</td>
                                                <td style={{ padding: '4px', border: '1px solid #ccc' }}>
                                                {group.jobOrders[0]?.job_date
                                                    ? new Date(group.jobOrders[0]?.job_date)
                                                        .toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit' })
                                                        .replace(/ /g, '-')
                                                    : ''}
                                                </td>
                                                <td style={{ padding: '4px', border: '1px solid #ccc' }}>Dispatch Time</td>
                                                <td style={{ padding: '4px', border: '1px solid #ccc' }}>
                                                {group.jobOrders[0]?.endorsement_dispatch_time
                                                    ? convertToAmPm(group.jobOrders[0].endorsement_dispatch_time)
                                                    : ''}
                                                </td>
                                            </tr>

                                            {/* Row 2: Driver | {endorsement_form_driver} | Vehicle | {endorsement_vehicle} */}
                                            <tr>
                                                <td style={{ padding: '4px', border: '1px solid #ccc' }}>Driver</td>
                                                <td style={{ padding: '4px', border: '1px solid #ccc' }}>
                                                {group.jobOrders[0]?.endorsement_form_driver || ''}
                                                </td>
                                                <td style={{ padding: '4px', border: '1px solid #ccc' }}>Vehicle</td>
                                                <td style={{ padding: '4px', border: '1px solid #ccc' }}>
                                                {group.jobOrders[0]?.endorsement_vehicle || ''}
                                                </td>
                                            </tr>

                                            {/* Row 3: Technicians | {technicians} (span 3 columns) */}
                                            <tr>
                                                <td style={{ padding: '4px', border: '1px solid #ccc' }}>Technicians</td>
                                                <td style={{ padding: '4px', border: '1px solid #ccc' }} colSpan={3}>
                                                {group.technicians
                                                    .map((t) => `${t.firstname} ${t.lastname}`)
                                                    .join(', ')}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Grid>
                            </Grid>
                            <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Box
                                    component="img"
                                    src={logo}
                                    alt="Pest Control Logo"
                                    sx={{
                                        width: "auto",
                                        maxWidth: "100%",
                                    }}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center'
                                }}
                            >
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        fontWeight: 'bold',
                                        fontSize: '1.2rem', // Adjust as desired
                                    }}
                                >
                                    Endorsement Form For Operations
                                </Typography>

                                <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                    Form#: OPS-ADM-OP-01F4
                                </Typography>
                            </Grid>
                            <Grid
                                item
                                xs={3}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'flex-start', // Align left
                                    textAlign: 'left',        // Align text to the left

                                }}
                            >
                                <Typography variant="body2" sx={{ fontSize: '11px' }}>
                                    1. Please read carefully
                                    <br />
                                    2. Know your roles and responsibility for the day
                                    <br />
                                    3. Pray for your safety and secure all of your belongings.
                                    <br />
                                    4. Return this form after treatment
                                </Typography>
                            </Grid>



                        </Grid>

                        {/* Table with job orders */}
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <TableContainer
                                    component={Paper}
                                    sx={{
                                        boxShadow: 'none',
                                        padding: 0,
                                        margin: 0,
                                        overflowX: 'auto',
                                        position: 'relative'
                                    }}
                                >
                                    <Table
                                        size="small"
                                        className="print-table"
                                        sx={{
                                            tableLayout: 'auto',
                                            borderCollapse: 'collapse',
                                            '& .MuiTableCell-root': {
                                                fontSize: '8px',
                                                padding: '2px', // Minimal padding for a compact layout
                                                border: '1px solid #ccc'
                                            }
                                        }}
                                    >
                                        <TableHead>
                                            <TableRow
                                                sx={{
                                                    backgroundColor: '#9BC2E6',
                                                    WebkitPrintColorAdjust: 'exact', // forces color printing in WebKit browsers
                                                    printColorAdjust: 'exact', // for other browsers
                                                }}
                                            >
                                                <TableCell
                                                    sx={{
                                                        whiteSpace: 'normal',
                                                        lineHeight: 1,
                                                        padding: '2px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    Endorser Name
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        whiteSpace: 'normal',
                                                        lineHeight: 1,
                                                        padding: '2px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    Endorser Contact Number
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        whiteSpace: 'normal',
                                                        lineHeight: 1,
                                                        padding: '2px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    Service Availed
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        whiteSpace: 'normal',
                                                        lineHeight: 1,
                                                        padding: '2px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    Job Description
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        whiteSpace: 'normal',
                                                        lineHeight: 1,
                                                        padding: '2px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    Client
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        whiteSpace: 'normal',
                                                        lineHeight: 1,
                                                        padding: '2px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    Preferred Time
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        whiteSpace: 'normal',
                                                        lineHeight: 1,
                                                        padding: '2px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    Address
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        whiteSpace: 'normal',
                                                        lineHeight: 1,
                                                        padding: '2px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    Landmark
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        whiteSpace: 'normal',
                                                        lineHeight: 1,
                                                        padding: '2px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    Contact Person
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        whiteSpace: 'normal',
                                                        lineHeight: 1,
                                                        padding: '2px',
                                                        width: '100px',
                                                        minWidth: '100px',
                                                        maxWidth: '100px',
                                                        overflowWrap: 'break-word',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    Client Contact Details
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        whiteSpace: 'normal',
                                                        lineHeight: 1,
                                                        padding: '2px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    Status of Last Visit
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        whiteSpace: 'normal',
                                                        lineHeight: 1,
                                                        padding: '2px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    Required Documents to Bring
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        whiteSpace: 'normal',
                                                        lineHeight: 1,
                                                        padding: '2px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    Size in sqm
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        whiteSpace: 'normal',
                                                        lineHeight: 1,
                                                        padding: '2px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    Price
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        whiteSpace: 'normal',
                                                        lineHeight: 1,
                                                        padding: '2px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    Payment Method
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        whiteSpace: 'normal',
                                                        lineHeight: 1,
                                                        padding: '2px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    Equipment to Bring
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        whiteSpace: 'normal',
                                                        lineHeight: 1,
                                                        padding: '2px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    Required Chemical
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        whiteSpace: 'normal',
                                                        lineHeight: 1,
                                                        padding: '2px',
                                                        width: '100px',
                                                        minWidth: '100px',
                                                        maxWidth: '100px',
                                                        overflowWrap: 'break-word',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    Special Notes
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        whiteSpace: 'normal',
                                                        lineHeight: 1,
                                                        padding: '2px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    Number of Visits per Month
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        whiteSpace: 'normal',
                                                        lineHeight: 1,
                                                        padding: '2px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    With Complaints
                                                </TableCell>

                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {[...group.jobOrders]
                                                .sort((a, b) => {
                                                    // Convert job_date strings to Date objects for comparison.
                                                    const dateA = new Date(a.job_date);
                                                    const dateB = new Date(b.job_date);

                                                    // If the job dates differ, sort by date.
                                                    if (dateA.getTime() !== dateB.getTime()) {
                                                        return dateA - dateB;
                                                    }

                                                    // Otherwise, sort by start_time.
                                                    const timeA = new Date(`1970-01-01T${a.start_time}:00`);
                                                    const timeB = new Date(`1970-01-01T${b.start_time}:00`);
                                                    return timeA - timeB;
                                                })
                                                .map((jobOrder) => (
                                                    <TableRow key={jobOrder.id}>
                                                        <TableCell>{jobOrder.endorser_name || ''}</TableCell>
                                                        <TableCell>{jobOrder.endorser_contact_number || ''}</TableCell>
                                                        <TableCell>
                                                            {formatList(jobOrder.job_types, normalizeJobTypeKeyToLabel)}
                                                        </TableCell>
                                                        <TableCell>
                                                            {formatList(jobOrder.job_description, normalizeJobDescriptionKeyToLabel)}
                                                        </TableCell>
                                                        <TableCell>{jobOrder.client.name}</TableCell>
                                                        <TableCell>
                                                            <div>
                                                                <strong>Date:</strong> {formatJobDateToDDMMMYYYY(jobOrder.job_date)}
                                                            </div>
                                                            <div>
                                                                <strong>Time:</strong> {convertToAmPm(jobOrder.start_time)} - {convertToAmPm(jobOrder.end_time)}
                                                            </div>
                                                        </TableCell>

                                                        <TableCell>
                                                            {jobOrder.client.address.house_unit_street || ''}, {jobOrder.client.address.barangay || ''}, {jobOrder.client.address.city || ''}, {jobOrder.client.address.metro_province || ''}
                                                        </TableCell>
                                                        <TableCell>{jobOrder.landmark}</TableCell>
                                                        <TableCell>
                                                            {jobOrder.client.contact.firstname} {jobOrder.client.contact.lastname}
                                                        </TableCell>
                                                        <TableCell
                                                            sx={{
                                                                whiteSpace: 'normal',
                                                                lineHeight: 1,
                                                                padding: '2px',
                                                                width: '100px',
                                                                minWidth: '100px',
                                                                maxWidth: '100px',
                                                                overflowWrap: 'break-word'
                                                            }}
                                                        >
                                                            {jobOrder.client.contact?.number?.type || ''}: {jobOrder.client.contact?.number?.number || ''}
                                                            <br />
                                                            {jobOrder.client.contact?.email?.email || ''}
                                                        </TableCell>
                                                        <TableCell>
                                                            {jobOrder.current_status ? (
                                                                typeof jobOrder.current_status === "string" ? (
                                                                    jobOrder.current_status
                                                                        .split("_")
                                                                        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                                                                        .join(" ")
                                                                ) : (
                                                                    jobOrder.current_status
                                                                )
                                                            ) : (
                                                                ""
                                                            )}
                                                        </TableCell>
                                                        <TableCell>
                                                            {formatList(jobOrder.documents_to_bring, normalizeDocumentKeyToLabel)}
                                                        </TableCell>
                                                        <TableCell>{jobOrder.client.address.area}</TableCell>
                                                        <TableCell>{jobOrder.price}</TableCell>
                                                        <TableCell>
                                                            {Array.isArray(jobOrder.payment_method)
                                                                ? jobOrder.payment_method.map((pm) => pm.label).join(", ")
                                                                : jobOrder.payment_method || ""}
                                                        </TableCell>

                                                        <TableCell>
                                                            {formatList(jobOrder.equipment, normalizeEquipmentKeyToLabel)}
                                                        </TableCell>
                                                        <TableCell>{jobOrder.required_chemical}</TableCell>
                                                        <TableCell
                                                            sx={{
                                                                whiteSpace: 'normal',
                                                                lineHeight: 1,
                                                                padding: '2px',
                                                                width: '100px',
                                                                minWidth: '100px',
                                                                maxWidth: '100px',
                                                                overflowWrap: 'break-word'
                                                            }}
                                                        >
                                                            {jobOrder.special_notes}
                                                        </TableCell>
                                                        <TableCell>{jobOrder.number_of_visits_per_month}</TableCell>
                                                        <TableCell>
                                                            {jobOrder.client_complaints
                                                                ? jobOrder.client_complaints.charAt(0).toUpperCase() +
                                                                jobOrder.client_complaints.slice(1)
                                                                : ""}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>


                            </Grid>
                        </Grid>
                    </Grid>
                    {/* Table for tech report */}
                    <Grid container sx={{ mt: 2 }}>
                        <Grid item xs={12}>
                            <table
                                style={{
                                    fontSize: '8px',
                                    borderCollapse: 'collapse',
                                    width: '33.33%',
                                    marginLeft: '2mm'
                                }}
                            >
                                <thead>
                                    <tr>
                                        <th style={{ padding: '2px', border: '1px solid #ccc', whiteSpace: 'nowrap', width: '1px' }}>Department</th>
                                        <th style={{ padding: '2px', border: '1px solid #ccc', whiteSpace: 'nowrap', width: '1px' }}>Total Qty</th>
                                        <th style={{ padding: '2px', border: '1px solid #ccc', whiteSpace: 'nowrap', width: '1px' }}>Done</th>
                                        <th style={{ padding: '2px', border: '1px solid #ccc', whiteSpace: 'nowrap', width: '1px' }}>Not Done</th>
                                        <th style={{ padding: '2px', border: '1px solid #ccc' }}>Reason</th>
                                        <th style={{ padding: '2px', border: '1px solid #ccc' }}>Corrections</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {['Operations', 'Sales', 'Finance', 'Logistics', 'Liaison', 'Total'].map((dept) => (
                                        <tr key={dept}>
                                            <td style={{ padding: '2px', border: '1px solid #ccc', whiteSpace: 'nowrap', width: '1px' }}>{dept}</td>
                                            <td style={{ padding: '2px', border: '1px solid #ccc', whiteSpace: 'nowrap', width: '1px' }}></td>
                                            <td style={{ padding: '2px', border: '1px solid #ccc', whiteSpace: 'nowrap', width: '1px' }}></td>
                                            <td style={{ padding: '2px', border: '1px solid #ccc', whiteSpace: 'nowrap', width: '1px' }}></td>
                                            <td style={{ padding: '2px', border: '1px solid #ccc' }}></td>
                                            <td style={{ padding: '2px', border: '1px solid #ccc' }}></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        sx={{
                            display: 'none',
                            '@media print': {
                                display: 'flex',
                                position: 'fixed',
                                bottom: 0,
                                left: 0,
                                width: '100%',
                                backgroundColor: '#fff', // optional: set a background color so it prints clearly
                                zIndex: 1000 // ensures it stays on top if needed
                            }
                        }}
                    >
                        {/* <Grid item xs={12}>
                            <Box
                                component="img"
                                src={footer}
                                alt="footer"
                                sx={{sal
                                    width: "auto",
                                    maxWidth: "100%",
                                }}
                            />
                        </Grid> */}
                    </Grid>
                </Grid>
            </div>
        </>
    );
};

function ViewEndorsementForm() {
    const location = useLocation();
    const { group } = location.state || {};
    const [groupDisplay, setGroupDisplay] = useState(group)
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const navigate = useNavigate();

    const convertToAmPm = (time24) => {
        const [hour, minute] = time24.split(':');
        const hourNum = parseInt(hour, 10);
        const suffix = hourNum >= 12 ? 'PM' : 'AM';
        const hour12 = hourNum % 12 || 12;
        return `${hour12}:${minute} ${suffix}`;
    };

    const handleDownloadPDF = async () => {
        const input = document.getElementById('print-area');
        if (!input) return;
        setIsLoading(true);
        try {
            // temporarily clone and force-show it at top-left
            const clone = input.cloneNode(true);
            clone.id = 'print-area-clone';
            clone.style.position = 'absolute';
            clone.style.top = '0';
            clone.style.left = '0';
            clone.style.display = 'block';            // override .print-only
            clone.style.visibility = 'visible';
            document.body.appendChild(clone);

            const canvas = await html2canvas(clone, { useCORS: true, allowTaint: true, scale: 2 });
            const imgData = canvas.toDataURL('image/jpeg', 1.0);
            const pdf = new jsPDF('landscape', 'mm', 'letter');

            // leave 10mm margins on each side
            const margin = 10;
            const pdfWidth = pdf.internal.pageSize.getWidth() - margin * 2;
            const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
            pdf.addImage(imgData, 'JPEG', margin, margin, pdfWidth, pdfHeight);

            // Build filename using job date
            const rawDate = groupDisplay?.jobOrders?.[0]?.job_date || new Date().toISOString();
            const jobDate = formatJobDateToDDMMMYYYY(rawDate);
            pdf.save(`endorsement-form-${jobDate}.pdf`);
        } catch (err) {
            console.error('PDF generation error:', err);
            setErrorMessage('Failed to generate PDF.');
        } finally {
            // cleanup
            const c = document.getElementById('print-area-clone');
            if (c) document.body.removeChild(c);
            setIsLoading(false);
        }
    };


    useEffect(() => {
        if (group?.jobOrders) {
            const groupWithJobScope = {
                ...group,
                jobOrders: group.jobOrders.map((job) => {
                    const jobScope = job.competencies
                        ?.filter((competency) => competency !== "driving_2_wheels" && competency !== "driving_4_wheels")
                        .map((competency) => {
                            // Format the competency name
                            const formattedCompetency = competency
                                .replace(/_/g, ' ') // Replace underscores with spaces
                                .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word

                            // Determine specializationKey
                            const specializationKey = competency === "general_pest_control" ? "general_pest_control" : "termite";

                            // Format specialization words
                            const formattedSpecialization = (job.specialization?.[specializationKey] || []).map((word) =>
                                word.length === 2
                                    ? word.toUpperCase() // Capitalize 2-letter words (e.g., "QB")
                                    : word.charAt(0).toUpperCase() + word.slice(1) // Capitalize the first letter of other words
                            );

                            return {
                                competency: formattedCompetency,
                                specialization: formattedSpecialization,
                            };
                        }) || [];

                    return {
                        ...job,
                        job_scope: jobScope, // Add job_scope to each jobOrder
                    };
                }),
            };

            setGroupDisplay(groupWithJobScope); // Update the state with the modified group
        }
    }, [group]); // Trigger when the `group` prop changes

    return (
        <BaseFormWrapper
            titleIcon={<FactCheckIcon />}
            title="Operations"
            subTitle="Manage Endorsement Form"
            subTitleRoute="/manage-endorsement-form"
            formTitle="View Endorsement Form"
            successMessage={successMessage}
            setSuccessMessage={setSuccessMessage}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            isLoading={isLoading}
        >
            <style>
                {`
                    @page {
                    size: A4 landscape;
                    margin: 10mm;
                    }
                    @media print {
                    /* Hide everything except print-area */
                    body * {
                        visibility: hidden;
                    }
                    #print-area, #print-area * {
                        visibility: visible;
                    }
                    #print-area {
                        position: absolute;
                        left: 0;
                        top: 0;
                    }
                    /* Override column widths for print only */
                    .print-table .MuiTableCell-root {
                        width: 50px !important;
                    }
                    /* You can also override other styles for print */
                    .print-table {
                        font-size: 0.2rem !important;
                    }
                    }
                `}
            </style>


            <Grid item xs={12}>
                <Grid container spacing={1} sx={{ mb: 2 }}>
                    <Grid item xs={12}>
                        <Grid container spacing={1}>
                            <table style={{ fontSize: '0.8rem', width: '50%', borderCollapse: 'collapse', marginLeft: '10px' }}>
                                <tbody>
                                    {/* Row 1: Date | {job_date} | Dispatch Time | {endorsement_dispatch_time} */}
                                    <tr>
                                        <td style={{ padding: '4px', border: '1px solid #ccc' }}>Date</td>
                                        <td style={{ padding: '4px', border: '1px solid #ccc' }}>
                                        {group.jobOrders[0]?.job_date
                                            ? new Date(group.jobOrders[0]?.job_date)
                                                .toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit' })
                                                .replace(/ /g, '-')
                                            : ''}
                                        </td>
                                        <td style={{ padding: '4px', border: '1px solid #ccc' }}>Dispatch Time</td>
                                        <td style={{ padding: '4px', border: '1px solid #ccc' }}>
                                        {group.jobOrders[0]?.endorsement_dispatch_time
                                            ? convertToAmPm(group.jobOrders[0].endorsement_dispatch_time)
                                            : ''}
                                        </td>
                                    </tr>

                                    {/* Row 2: Driver | {endorsement_form_driver} | Vehicle | {endorsement_vehicle} */}
                                    <tr>
                                        <td style={{ padding: '4px', border: '1px solid #ccc' }}>Driver</td>
                                        <td style={{ padding: '4px', border: '1px solid #ccc' }}>
                                        {group.jobOrders[0]?.endorsement_form_driver || ''}
                                        </td>
                                        <td style={{ padding: '4px', border: '1px solid #ccc' }}>Vehicle</td>
                                        <td style={{ padding: '4px', border: '1px solid #ccc' }}>
                                        {group.jobOrders[0]?.endorsement_vehicle || ''}
                                        </td>
                                    </tr>

                                    {/* Row 3: Technicians | {technicians} (span 3 columns) */}
                                    <tr>
                                        <td style={{ padding: '4px', border: '1px solid #ccc' }}>Technicians</td>
                                        <td style={{ padding: '4px', border: '1px solid #ccc' }} colSpan={3}>
                                        {group.technicians
                                            .map((t) => `${t.firstname} ${t.lastname}`)
                                            .join(', ')}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </Grid>

                    </Grid>
                </Grid>

                <StyledHr />
                
                <Grid container spacing={1} style={{ marginTop: 10 }}>
                    <Grid item xs={12}>
                        <TableContainer
                            component={Paper}
                            sx={{
                                boxShadow: 'none',
                                padding: 0,
                                margin: 0,
                                overflowX: 'auto',
                                position: 'relative'
                            }}
                        >
                            <Table
                                size="small"
                                sx={{
                                    tableLayout: 'fixed',
                                    borderCollapse: 'collapse',
                                    '& .MuiTableCell-root': { fontSize: '0.8rem', padding: '4px', border: '1px solid #ccc' }
                                }}
                            >
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: 'lightgray' }}>
                                        <TableCell sx={{ width: '100px' }}>Endorser Name</TableCell>
                                        <TableCell sx={{ width: '100px' }}>Endorser Contact Number</TableCell>
                                        <TableCell sx={{ width: '100px' }}>Service Availed</TableCell>
                                        <TableCell sx={{ width: '200px' }}>Job Description</TableCell>
                                        <TableCell sx={{ width: '150px' }}>Client</TableCell>
                                        <TableCell sx={{ width: '150px' }}>Date</TableCell>
                                        <TableCell sx={{ width: '150px' }}>Preferred Time</TableCell>
                                        <TableCell sx={{ width: '200px' }}>Address</TableCell>
                                        <TableCell sx={{ width: '150px' }}>Landmark</TableCell>
                                        <TableCell sx={{ width: '100px' }}>Contact Person</TableCell>
                                        <TableCell sx={{ width: '250px' }}>Client Contact Details</TableCell>
                                        <TableCell sx={{ width: '200px' }}>Status of Last Visit</TableCell>
                                        <TableCell sx={{ width: '200px' }}>Required Documents to Bring</TableCell>
                                        <TableCell sx={{ width: '50px' }}>Size in sqm</TableCell>
                                        {/* <TableCell sx={{ width: '300px' }}>Job Scope</TableCell> */}
                                        <TableCell sx={{ width: '50px' }}>Price</TableCell>
                                        <TableCell sx={{ width: '100px' }}>Payment Method</TableCell>
                                        <TableCell sx={{ width: '150px' }}>Equipment to Bring</TableCell>
                                        <TableCell sx={{ width: '150px' }}>Required Chemical</TableCell>
                                        <TableCell sx={{ width: '200px' }}>Special Notes</TableCell>
                                        <TableCell sx={{ width: '150px' }}>Number of Visits per Month</TableCell>
                                        <TableCell sx={{ width: '100px' }}>With Complaints</TableCell>
                                        <TableCell sx={{ width: '100px' }}>Schedule Confirmed with Client</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {[...group.jobOrders]
                                        .sort((a, b) => {
                                            // Convert job_date strings to Date objects for comparison.
                                            const dateA = new Date(a.job_date);
                                            const dateB = new Date(b.job_date);

                                            // If the job dates differ, sort by date.
                                            if (dateA.getTime() !== dateB.getTime()) {
                                                return dateA - dateB;
                                            }

                                            // Otherwise, sort by start_time.
                                            const timeA = new Date(`1970-01-01T${a.start_time}:00`);
                                            const timeB = new Date(`1970-01-01T${b.start_time}:00`);
                                            return timeA - timeB;
                                        })
                                        .map((jobOrder) => (
                                            <TableRow key={jobOrder.id}>
                                                <TableCell>{jobOrder.endorser_name}</TableCell>
                                                <TableCell>{jobOrder.endorser_contact_number}</TableCell>
                                                <TableCell>
                                                    {formatList(jobOrder.job_types, normalizeJobTypeKeyToLabel)}
                                                </TableCell>
                                                <TableCell>
                                                    {formatList(jobOrder.job_description, normalizeJobDescriptionKeyToLabel)}
                                                </TableCell>
                                                <TableCell>{jobOrder.client.name}</TableCell>
                                                <TableCell>{formatJobDateToDDMMMYYYY(jobOrder.job_date)}</TableCell>
                                                <TableCell>
                                                    {convertToAmPm(jobOrder.start_time)} - {convertToAmPm(jobOrder.end_time)}
                                                </TableCell>
                                                <TableCell>
                                                    {jobOrder.client.address.house_unit_street || ''}, {jobOrder.client.address.barangay || ''}, {jobOrder.client.address.city || ''}, {jobOrder.client.address.metro_province || ''}
                                                </TableCell>
                                                <TableCell>{jobOrder.landmark}</TableCell>
                                                <TableCell>
                                                    {jobOrder.client.contact.firstname} {jobOrder.client.contact.lastname}
                                                </TableCell>
                                                <TableCell>
                                                    {jobOrder.client.contact?.number?.type || ''}: {jobOrder.client.contact?.number?.number || ''}
                                                    <br />
                                                    {jobOrder.client.contact?.email?.email || ''}
                                                </TableCell>

                                                <TableCell>
                                                    {jobOrder.current_status ? (
                                                        typeof jobOrder.current_status === "string" ? (
                                                            jobOrder.current_status
                                                                .split("_")
                                                                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                                                                .join(" ")
                                                        ) : (
                                                            jobOrder.current_status
                                                        )
                                                    ) : (
                                                        ""
                                                    )}
                                                </TableCell>
                                                <TableCell>
                                                    {formatList(jobOrder.documents_to_bring, normalizeDocumentKeyToLabel)}
                                                </TableCell>
                                                <TableCell>{jobOrder.client.address.area}</TableCell>
                                                <TableCell>{jobOrder.price}</TableCell>
                                                <TableCell>
                                                    {Array.isArray(jobOrder.payment_method)
                                                        ? jobOrder.payment_method.map((pm) => pm.label).join(", ")
                                                        : jobOrder.payment_method || ""}
                                                </TableCell>

                                                <TableCell>
                                                    {formatList(jobOrder.equipment, normalizeEquipmentKeyToLabel)}
                                                </TableCell>

                                                <TableCell>{jobOrder.required_chemical}</TableCell>
                                                <TableCell>{jobOrder.special_notes}</TableCell>
                                                <TableCell>{jobOrder.number_of_visits_per_month}</TableCell>
                                                <TableCell>
                                                    {jobOrder.client_complaints
                                                        ? jobOrder.client_complaints.charAt(0).toUpperCase() +
                                                        jobOrder.client_complaints.slice(1)
                                                        : ""}
                                                </TableCell>
                                                <TableCell>
                                                    {jobOrder.schedule_confirmed
                                                        ? jobOrder.schedule_confirmed.charAt(0).toUpperCase() +
                                                        jobOrder.schedule_confirmed.slice(1)
                                                        : ""}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>


                            </Table>
                        </TableContainer>

                    </Grid>
                </Grid>
            </Grid>

            {/* Buttons */}
            <Grid container spacing={1} justifyContent="space-between" alignItems="center" sx={{ mt: 2, mb: 2, mr: 2 }}>
                <Grid item>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleDownloadPDF}
                        sx={{ fontSize: '0.875rem', ml: 2 }}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Generating...' : 'Download as PDF'}
                    </Button>
                </Grid>

                <Grid item>
                    <Grid container spacing={1}>
                        <Grid item>
                            <Button
                                variant="outlined"
                                color="secondary"
                                onClick={() => navigate("/manage-endorsement-form")}
                                sx={{
                                    fontSize: "0.875rem",
                                    color: "#FF4C4C",
                                    borderColor: "#FF4C4C"                                    
                                }}
                                disabled={isLoading}
                            >
                                Cancel
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                sx={{ mr: 2, fontSize: "0.875rem" }}
                                onClick={() => window.print()}
                                disabled={isLoading}
                            >
                                Print
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <PrintComponent group={group} convertToAmPm={convertToAmPm} />
        </BaseFormWrapper>        
    );
}

export default ViewEndorsementForm;